import {
    ChangeDetectionStrategy,
    ChangeDetectorRef, Component,
    DoCheck,
    ElementRef,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output, Pipe, PipeTransform,
    Renderer2,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import {
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    ReactiveFormsModule,
    FormsModule
} from '@angular/forms';
import {
    DEFAULT_EMULATOR_ROUTE_NAME,
    DEFAULT_NOT_VALID_EMULATOR_ROUTE_NAME,
    EmulatorDisplay,
    EmulatorMessage,
    EmulatorMessageTypes,
} from '../../../../shared/models';
import {FlowManagerService} from '../../services/flow-manager.service';
import * as config from '../../../../shared/utils/config';
import {SMS, USSD, WEBCHAT, WHATSAPP, RCS, CHANNEL_NAME} from '../../../../shared/utils/config';
import {swalMini, Utils} from '../../../../shared/utils/utils';
import {Channel, InteractiveMessage, LocationMessage, Route} from '../../../../shared/models';
import {delay, filter, map, mergeMap, reduce, repeatWhen, retryWhen, switchMap, tap} from 'rxjs/operators';
import {interval, merge, Observable, of, Subject, Subscription} from 'rxjs';
import values from 'lodash/values';
import mapValues from 'lodash/mapValues';
import sortBy from 'lodash/sortBy';
import {filter as _filter} from 'lodash';
import {UploadRes} from '../../../assets-library/services/asset-library.model';
import filesize from 'filesize/lib/filesize.es6.js';
import CryptoJS from 'crypto-js';
import {AssetsService} from '../../../assets-library/services/assets.service';
import moment from 'moment';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {
    Permissions,
    VoiceNoteData,
} from './chat-bubble/voice-note/services/voice-note.service';
import {isTranslate} from './translator/inbound-translator';
import {
    outboundTranslator,
} from './translator/outbound-translator';
import {SharedService} from '../../../../core/services/store/shared-store/shared-storage.service';
import {ManagementService} from '../../../../core/services/management/management.service';
import {WebsocketService} from '../../../../core/services/emulator/websocket.service';
import {MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from '@angular/material/expansion';
import {WebSocketSubject} from 'rxjs/webSocket';
import {OAuthService} from 'angular-oauth2-oidc';
import {SharedStorageService} from '../../../../core/services/storage/shared-storage.service';
import {Store} from '@ngrx/store';
import {StateService} from '../../../../core/services/store/state/state.service';
import {ZoomService} from '../../services/flowBuilder/zoom.service';
import {FlowBuilderService} from '../../services/flowBuilder/flow-builder.service';
import {CMSConditions} from '../../../../shared/models';
import {MatAutocomplete, MatAutocompleteTrigger} from '@angular/material/autocomplete';
import find from 'lodash/find';
import {clearEmulatorStateAction, flowEventAction, selectFlowEventPath} from '../../../../core';
import {FlowModeState} from '../../../../shared/models/state/Flow';
import {MatSelect, MatSelectTrigger, MatOption, MatOptgroup} from '@angular/material/select';
import {MatCheckbox} from '@angular/material/checkbox';
import {NgClass, NgTemplateOutlet, NgStyle, AsyncPipe} from '@angular/common';
import {ɵEmptyOutletComponent} from '@angular/router';
import {MatInput} from '@angular/material/input';
import {CMSComponent} from '../../../../shared/components/cms/cms.component';
import {MatTooltip} from '@angular/material/tooltip';
import {ChatBubbleComponent} from './chat-bubble/chat-bubble.component';
import {VoiceNoteComponent} from './chat-bubble/voice-note/voice-note.component';
import {ShowLocationComponent} from './show-location/show-location.component';
import {MatProgressBar} from '@angular/material/progress-bar';
import {SendContactCardComponent} from './chat-bubble/send-contact-card/send-contact-card.component';
import {TruncateFileNamePipe} from '../../../../shared/utils/pipes/truncate_file_name';
import {
    Contact,
    ContentInteractive,
    ContentLocation,
    ContentMedia,
    OutboundTranslator
} from './translator/translatorUtils';
import {ChannelNamePipe} from "../../../../shared/utils/pipes/ChannelNamePipe";

type InputState = 'text' | 'uploading' | 'voiceNote' | 'location';


enum INPUT_PLACEHOLDER {
    START = 'Say hi to start',
    INPUT = 'Enter message...'
}


@Pipe({name: 'getFlowPath'})
export class GetFlowPathPipe implements PipeTransform {

    constructor(private flowManagerService: FlowManagerService) {
    }

    transform(name: string): string {
        const flow = this.flowManagerService.getFlowByName(name);
        if (flow && flow.directory) {
            return flow.directory;
        }
    }
}

@Pipe({name: 'checkShowAdditional'})
export class CheckShowAdditionalPipe implements PipeTransform {
    transform(element: any, showAdditionalSettings): boolean {
        if (element.additional) {
            return showAdditionalSettings;
        }
        return true;
    }
}


@Pipe({name: 'buildCMSConditions'})
export class BuildCMSConditionsPipe implements PipeTransform {
    transform(field: string, channelId: number): CMSConditions {
        return {
            channelId: channelId,
            field: field.replace(/\s/g, ''),
            size: '17',
            type: 'preview',
        };
    }
}

@Component({
    selector: 'app-preview',
    templateUrl: './preview.component.html',
    styleUrls: ['./preview.component.scss'],
    animations: [
        trigger('openClose', [
            state('open', style({
                height: '*',
                opacity: 1,
            })),
            state('closed', style({
                height: '0',
                opacity: 0,
            })),
            transition('open => closed', [animate('0.35s')]),
            transition('closed => open', [animate('0.35s')]),
        ]),
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatSelect, NgClass, ReactiveFormsModule, FormsModule, MatSelectTrigger, MatOption, NgTemplateOutlet, ɵEmptyOutletComponent, MatOptgroup, MatInput, MatAutocompleteTrigger, MatAutocomplete, NgStyle, CMSComponent, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatTooltip, ChatBubbleComponent, VoiceNoteComponent, ShowLocationComponent, MatProgressBar, SendContactCardComponent, AsyncPipe, TruncateFileNamePipe, ChannelNamePipe, GetFlowPathPipe, CheckShowAdditionalPipe, BuildCMSConditionsPipe, MatCheckbox]
})
export class PreviewComponent implements OnInit, OnDestroy, DoCheck {
    private showMedia = false;
    showEmulatorDialog = false;
    showRestartPopUp = false;
    showSendContactCard = false;
    emulatorChannelConfig: Observable<Channel>;

    @ViewChild('restartAnchor') questionMarkRef: ElementRef;
    @ViewChild('restartContainer') bubbleRef: ElementRef;
    private selectFlowEventPathSubscription: Subscription;
    @ViewChild('auto') routeAutocomplete: MatAutocomplete;
    @Output() updateFlow = new EventEmitter<String>();

    channels: Channel[];
    private flowModeSubscription: Subscription;
    private timeout: number;

    readonly MEDIA_SUPPORT: {
        [index: number]: { media: boolean, location: boolean, voiceNote: boolean, contact: boolean }
    } = {
        8: {
            media: true,
            location: true,
            voiceNote: true,
            contact: true
        },
        12: {
            media: true,
            location: false,
            voiceNote: false,
            contact: false
        },
    }

    constructor(
        private sharedStorage: SharedService,
        private sharedStorageService: SharedStorageService,
        private flowManagerService: FlowManagerService,
        private websocketService: WebsocketService,
        private managementService: ManagementService,
        private utils: Utils,
        private formbuilder: UntypedFormBuilder,
        private assetsService: AssetsService,
        private oauthService: OAuthService,
        private store: Store,
        private stateService: StateService,
        private renderer: Renderer2,
        private zoomService: ZoomService,
        private flowBuilderService: FlowBuilderService,
        private sharedService: SharedService,
        private cdr: ChangeDetectorRef,
    ) {
        this.emulatorFormGroup = this.createEmulatorForm();
        this.oauthService.loadDiscoveryDocumentAndTryLogin().then((isLoggedIn) => {
            if (isLoggedIn) {
                let storedUserInfo = this.sharedStorageService.get('userInfo');
                if (storedUserInfo == null) {
                    storedUserInfo = this.utils.getUserInfo();
                    this.initializeWithUserInfo(storedUserInfo);
                } else {
                    this.initializeWithUserInfo(storedUserInfo);
                }
            }
        });
    }

    public emulatorDisplay: Array<EmulatorDisplay> = [];
    public channelRoutes: Observable<Channel[]>;
    public emulatorFormGroup: UntypedFormGroup = new UntypedFormGroup({});
    public emulatorConfig = config.EMULATOR_INPUTS;
    public route = new UntypedFormControl('');
    public network = new UntypedFormControl('');
    public sourceId = new UntypedFormControl('');
    public isBsuid = new UntypedFormControl(false);
    public triggerContactBookFlow = new UntypedFormControl(false);
    public imsi = new UntypedFormControl('');
    public mnoSessionId = new UntypedFormControl('');
    public msg = new UntypedFormControl('');
    public selectedChannel: number = 8;
    public sessionId = '';
    public emulatorMessages: EmulatorMessage[] = [];
    public emulatorDisplayMessages$: Observable<EmulatorMessage[]>;
    public emulatorReplyMessages: Subject<EmulatorMessage> = new Subject<EmulatorMessage>();
    public emulatorResponse = new UntypedFormControl('');
    public userProfile: any;
    public focusResponseInput = false;
    public channelRoutesList: Array<[Object]> = [];
    public filteredRoutesList: Array<[Object]> = [];
    public selectedMobileNetwork: Number = 1;
    public showDismiss: Boolean = false;
    public canceled: Boolean = false;
    public uploadProgressAction: any = {
        status: null,
        progress: 0,
        fileName: null,
        uploadCompleted: false,
        size: 0,
        error: false,
        src: null,
        reference: null,
    };
    public mediaData: ContentMedia = {
        contentType: null,
        byteSize: null,
        sha256Hash: null,
        caption: null,
        downloadUrl: null,
        fileName: null,
        reference: null,
    };
    private clientsMap$: Observable<any>;
    private entityName: string;

    public inputState: InputState = 'text';
    public inputPlaceholder: INPUT_PLACEHOLDER = INPUT_PLACEHOLDER.INPUT;

    public emulatorResponseFormGroup: UntypedFormGroup = new UntypedFormGroup({
        emulatorResponse: this.emulatorResponse,
    });
    public userInfo: any;
    public previewModal: any = {
        isModalOpen: false,
        previewType: '',
        src: '',
    };

    private uploadMediaData: any = {
        file: null,
        encrypted: null,
        resolution: null,
    };
    public showAdditionalSettings = false;
    private isFormValid: boolean;

    public selectedRouteByDefault: any = {name: DEFAULT_EMULATOR_ROUTE_NAME};

    private _websocketEmulatorSubject$: WebSocketSubject<EmulatorMessage>;

    /*
      Returns a combined stream of EmulatorMessages for displaying.
       */
    private _websocketEmulatorMessages$: Observable<EmulatorMessage>;

    @ViewChild('responseInput') responseInput: ElementRef;
    @ViewChild('previewImageModule') previewImageModule: TemplateRef<any>;
    @ViewChild('fileUpload') fileUpload: ElementRef;
    @ViewChild(MatAutocompleteTrigger, {read: MatAutocompleteTrigger}) inputAutoComplete: MatAutocompleteTrigger;
    @ViewChild('selectArrow') selectArrow: ElementRef;
    @ViewChild('routeInput') routeInput: ElementRef;

    permission: Observable<Permissions>;
    startFlow: any = null;

    filterRoutes(value: String): void {
        if (value) {
            this.filteredRoutesList[this.selectedChannel] = _filter(
                this.channelRoutesList[this.selectedChannel],
                (option) => {
                    return option.name.toLowerCase().includes(value.toLowerCase());
                },
            );
        } else {
            this.filteredRoutesList[this.selectedChannel] = this.channelRoutesList[this.selectedChannel];
        }
    }

    isValidRoute(): string {
        if (this.stateService.getFlowMetaData().flowId &&
            this.stateService.getFlowMetaData().flowId !== null &&
            this.stateService.getFlowMetaData().flowId !== undefined) {
            return DEFAULT_EMULATOR_ROUTE_NAME;
        } else {
            return DEFAULT_NOT_VALID_EMULATOR_ROUTE_NAME;
        }
    }

    ngOnInit() {
        this.userInfo = this.sharedStorage.getUserInfo();
        this.getChannels();
        this.resetEmulator();
        this.clientsMap$ = this.managementService.getEntities();
        this.selectedRouteByDefault.name = this.isValidRoute();
        this.emulatorFormGroup.get('route').setValue(this.selectedRouteByDefault.name);
        this.channelRoutes.subscribe(
            data => {
                this.channels = data;
            },
        );
        this.startFlow = this.stateService.getFlowMetaData();
        this.zoomService.scrollTo('start');

        // Subscribe to route value changes for filtering
        this.emulatorFormGroup.get('route').valueChanges.subscribe(value => {
            this.filterRoutes(value);
        });
    }

    ngOnDestroy(): void {
        clearTimeout(this.timeout);
        this.resetNodeStyle();
        this.flowBuilderService.setDefaultStyles();
        this.selectFlowEventPathSubscription?.unsubscribe();
        this.flowModeSubscription?.unsubscribe();
        if (this.startFlow.flowId && this.startFlow.flowId !== this.sharedService.getFlowRef) {
            this.updateFlow.emit(this.startFlow.flowId);
        }
        if (this.stateService.getFlowMode() === FlowModeState.FLOW_MODE) {
            this.sendReleaseMsg();
        }
    }

    /**
     * Allows the user to enter text without first clearing the control
     */
    clearInput() {
        this.emulatorConfig[this.selectedChannel].find((obj) => obj['formControlName'] === 'route')['placeholder'] = this.emulatorFormGroup.get('route').value;
        this.emulatorFormGroup.get('route').setValue('');
    }

    /**
     * Sets the control back to the previous value if no new value was entered
     */
    setInput() {
        if (!this.emulatorFormGroup.get('route').value) {
            this.emulatorFormGroup.get('route').setValue(this.emulatorConfig[this.selectedChannel].find((obj) => obj['formControlName'] === 'route')['placeholder']);
        }
    }

    /**
     * Sets autocomplete open arrow and input focus styles
     */
    setFocusStyles() {
        this.selectArrow.nativeElement.style.transform = 'rotate(180deg) translateY(0px) translateX(-4px)';
        this.routeInput.nativeElement.style.borderColor = 'var(--clickatell-blue)';
        this.routeInput.nativeElement.style.backgroundColor = 'var(--greyscale-white)';
    }

    /**
     * Sets autocomplete closed arrow and input blur styles
     */
    setBlurStyles() {
        this.selectArrow.nativeElement.style.transform = 'rotate(0) translateY(2px)';
        this.routeInput.nativeElement.style.borderColor = '#e1e1e1';
        this.routeInput.nativeElement.style.backgroundColor = 'var(--greyscale-white)';
        this.setInput();
    }

    /**
     * Called when routes autocomplete panel is open
     */
    onPanelOpen() {
        this.setFocusStyles();
        this.clearInput();
    }

    /**
     * Called when routes autocomplete panel is closed
     */
    onPanelClosed() {
        this.setBlurStyles();
        this.setInput();
    }

    ngDoCheck() {
        const newIsFormValid = this.checkIsFormValid();
        if (this.isFormValid !== newIsFormValid) {
            this.isFormValid = newIsFormValid;
            this.cdr.markForCheck();
        }
    }


    public resetEmulator(testDetailsPanel?) {
        this.emulatorChannelConfig = this.flowManagerService.getChannelsById(this.selectedChannel.toString());

        if (this.selectedChannel === 7) {
            this._websocketEmulatorSubject$ = this.websocketService.connectV2<EmulatorMessage>();
        } else {
            this._websocketEmulatorSubject$ = this.websocketService.connectV3<EmulatorMessage>();
        }

        const messages = this._websocketEmulatorSubject$.pipe(
            retryWhen((errors) =>
                errors.pipe(
                    delay(2000),
                    tap((err) => console.warn('emulator websocket connection dropped retrying', err)),
                ),
            ),
            repeatWhen((complete) =>
                complete.pipe(
                    delay(2000),
                    tap((err) => console.warn('emulator websocket connection dropped retrying', err)),
                ),
            ),
        );

        const pingMessages = this.getPingEmulatorMessagesObservable();
        this._websocketEmulatorMessages$ = merge(messages, pingMessages);

        this.emulatorResponse.reset();
        this.emulatorDisplayMessages$ = this.getEmulatorMessages();
        this.emulatorDisplay = [];
        this.focusResponseInput = false;
        this.emulatorFormGroup.reset();
        this.sessionId = '';
        // this.closeWebsocket();
        this.showDismiss = false;
        if (testDetailsPanel) {
            testDetailsPanel.open();
        }
        if (this.selectedChannel !== USSD) {
            this.emulatorFormGroup.get('route').setValue(this.selectedRouteByDefault.name);

            if (this.startFlow) {
                this.updateFlow.emit(this.startFlow.flowId ? this.startFlow.flowId : '__NEW_FLOW__');
            }
        }
        this.store.dispatch(clearEmulatorStateAction());
    }

    private getPingEmulatorMessagesObservable() {
        let lastPing = -1;

        return interval(5000).pipe(
            filter(n => n > lastPing),
            map((n) => {
                lastPing = n;
                return {
                    messageType: EmulatorMessageTypes.PING,
                    clientId: 42,
                    message: 'bloo',
                    user: this.userInfo['user_id'],
                    tabId: this.utils.currentTabId(),
                    sourceId: '',
                    accessToken: this.oauthService.getAccessToken(),
                } as EmulatorMessage;
            }),
            tap((ping) => this._websocketEmulatorSubject$.next(ping)),
        );
    }

    buildEmulatorFlowRoute(): Route | any {
        return {
            name: this.selectedRouteByDefault.name,
            flowName: this.stateService.getFlowMetaData().flowName,
            start: 'start',
            channelId: 8,
            properties: {},
            entityType: this.userInfo['entityType'],
            entityId: this.userInfo['clientId'],
        };
    }

// TODO IA 21 March 2020 -> Reverted @Riaan changes we currently don't support telegram and sms. So I just added webchat
    private getChannels() {
        this.channelRoutes = this.flowManagerService.getChannels('dev').pipe(
            // update When we build other emulators
            mergeMap((x) => x),
            filter((channel: Channel) => {
                return (
                    channel.config['channel-id'] === config.WHATSAPP ||
                    channel.config['channel-id'] === config.USSD ||
                    channel.config['channel-id'] === config.SMS ||
                    channel.config['channel-id'] === config.RCS
                );
            }),
            reduce((channelsAcc: Channel[], channel: Channel) => {
                channelsAcc.push(channel);
                return channelsAcc;
            }, []),
            map((x) => {
                x.map((channel) => {
                    const routesArr: Array<Route> = values(
                        mapValues(channel.routes, (value, key) => {
                            value.name = key;
                            return value;
                        }),
                    );
                    this.channelRoutesList[channel.config['channel-id']] = sortBy(routesArr, (item) =>
                        item.name.toLocaleLowerCase(),
                    );
                    this.filteredRoutesList[channel.config['channel-id']] = sortBy(routesArr, (item) =>
                        item.name.toLocaleLowerCase(),
                    );
                    if (channel.config['channel-id'] !== USSD) {
                        this.channelRoutesList[channel.config['channel-id']].unshift(this.buildEmulatorFlowRoute());
                        this.filteredRoutesList[channel.config['channel-id']].unshift(this.buildEmulatorFlowRoute());
                    }
                });
                return x.sort((a: Channel, b: Channel) => {
                    const nameA = a.config['channel-name'];
                    const nameB = b.config['channel-name'];
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    // names must be equal
                    return 0;
                });
            }),
            map(channel => {
                for (const c of channel) {
                    const channelId = c.config['channel-id'];
                    if (channelId === 7 || channelId === 6) {
                        c.config['channel-name'] = c.config['channel-name'].toUpperCase();
                    }
                }
                return channel;
            }),
        );
    }

    private getEmulatorMessages(): Observable<EmulatorMessage[]> {
        const initMessages: Observable<EmulatorMessage> = this._websocketEmulatorMessages$.pipe(
            filter((emulatorMessage) => emulatorMessage.messageType === EmulatorMessageTypes.INIT),
            tap((initMessage) => {
                initMessage.user = this.userInfo['user_id'];
                initMessage.tabId = this.utils.currentTabId();
                initMessage.accessToken = this.sharedStorage.getAccessToken;
                this.inputPlaceholder = INPUT_PLACEHOLDER.START;
                this._websocketEmulatorSubject$.next(initMessage);
                this.cdr.markForCheck();
            }),
        );

        // reply messages from websocket
        const systemReplies: Observable<EmulatorMessage> = this._websocketEmulatorMessages$.pipe(
            filter((emulatorMessage) => !this.isPingPongMessage(emulatorMessage)), // ignore ping/pong messages
            tap((emulatorMessage) => {
                if (emulatorMessage.sessionId !== '') {
                    this.sessionId = emulatorMessage.sessionId;
                }
            }), // updates sessionId from system on the fly
            filter((emulatorMessage) => this.isSystemMessage(emulatorMessage)), // filters out messages for display
            filter((emulatorMessage) => !this.isSystemEvent(emulatorMessage)),
            map((emulatorMessage) => isTranslate(emulatorMessage)),
            tap((emulatorMessage) => {
                if (emulatorMessage.messageType === EmulatorMessageTypes.END) {
                    this.showDismiss = true;
                    this.cdr.markForCheck();
                }
            }),
        );

        const systemEvent: Observable<any> = this._websocketEmulatorMessages$.pipe(
            filter((emulatorMessage) => EmulatorMessageTypes.STATUS === emulatorMessage.messageType),
            map((emulatorMessage: EmulatorMessage) => isTranslate(emulatorMessage)),
            filter((emulatorMessage) => this.isSystemEvent(emulatorMessage)),
            tap((emulatorMessage: EmulatorMessage) => {
                for (const message of this.emulatorMessages) {
                    if (message?.mediaMetaData['messageId'] === emulatorMessage.channelPayload['event']['messageStatusUpdate'][0]['messageId']) {
                        message.mediaMetaData['messageStatus'] = emulatorMessage.mediaMetaData['status'];
                    }
                }
            }),
        );

        // messages from UI
        const userReplies: Observable<EmulatorMessage> = this.emulatorReplyMessages.asObservable().pipe(
            filter((emulatorMessage) => this.isUserMessage(emulatorMessage)),
            tap((emulatorMessage: EmulatorMessage) => {
                this.inputPlaceholder = INPUT_PLACEHOLDER.INPUT;
                if (this.selectedChannel === 8) {
                    this.showMedia = true;
                } else {
                    this.showMedia = false;
                }
                this.cdr.markForCheck();
            }),
        );

        // For system logs
        const flowEvent: Observable<EmulatorMessage> = this._websocketEmulatorMessages$.pipe(
            filter((message: EmulatorMessage) => !this.isPingPongMessage(message)), // ignore ping/pong messages
            filter((message: EmulatorMessage) => (this.isFlowEvent(message))), // filters out messages for logs
            tap((message: EmulatorMessage) => this.store.dispatch(flowEventAction({flowEvent: message.flowEvent}))), // Dispatch logs to store
            tap(() => this.setUpFlowEventListener()),
        );

        return merge(initMessages, systemReplies, systemEvent, userReplies, flowEvent).pipe(
            filter((emulatorMessage) => this.isMessage(emulatorMessage)),
            map((message) => {
                const newMessage = {...message, id: message.id || Date.now()};
                this.emulatorMessages = [...this.emulatorMessages, newMessage];
                this.cdr.markForCheck();
                return this.emulatorMessages;
            }),
        );
    }

    identify(index, item) {
        return item?.mediaMetaData?.messageId || item?.id || index;
    }

    public isMessage(emulatorMessage: EmulatorMessage) {
        return (
            emulatorMessage.messageType === EmulatorMessageTypes.MESSAGE ||
            emulatorMessage.messageType === EmulatorMessageTypes.END ||
            emulatorMessage.messageType === EmulatorMessageTypes.MESSAGE_REPLY ||
            emulatorMessage.messageType === EmulatorMessageTypes.START
        );
    }

    public isEndMessage(emulatorMessage: EmulatorMessage) {
        return emulatorMessage.messageType === EmulatorMessageTypes.END;
    }

    public isSystemEvent(emulatorMessage: EmulatorMessage) {
        return (EmulatorMessageTypes.STATUS === emulatorMessage.messageType &&
            'mediaMetaData' in emulatorMessage && emulatorMessage.mediaMetaData['bubbleType'] === 'notification');
    }

    public isSystemMessage(emulatorMessage: EmulatorMessage) {
        return (
            emulatorMessage.messageType === EmulatorMessageTypes.MESSAGE ||
            emulatorMessage.messageType === EmulatorMessageTypes.END
        );
    }

    public isPingPongMessage(emulatorMessage: EmulatorMessage) {
        return (
            emulatorMessage.messageType === EmulatorMessageTypes.PING ||
            emulatorMessage.messageType === EmulatorMessageTypes.PONG
        );
    }

    public isUserMessage(emulatorMessage: EmulatorMessage) {
        return (
            emulatorMessage.messageType === EmulatorMessageTypes.MESSAGE_REPLY ||
            emulatorMessage.messageType === EmulatorMessageTypes.START
        );
    }

    private isFlowEvent(emulatorMessage: EmulatorMessage) {
        return (
            emulatorMessage.messageType === EmulatorMessageTypes.FLOW_EVENT
        );
    }

    getObjectKeys(object: Object) {
        return Object.keys(object);
    }

    createEmulatorForm(): UntypedFormGroup {
        return this.formbuilder.group({
            imsi: this.imsi,
            mnoSessionId: this.mnoSessionId,
            sourceId: this.sourceId,
            network: this.network,
            route: this.route,
            msg: this.msg,
        });
    }

    /**
     * removes opacity from nodes, connectors and labels
     * @param source the parent of the target node
     * @param target the node that is being executed
     */
    setExecutedNodeStyle(source: string, target: string) {
        const element = document.getElementById(target);
        if (element) {
            this.renderer.removeClass(element, 'notExecutedNode');
        }
        this.flowBuilderService.setExecutedStyles(source, target);
        this.zoomService.scrollTo(target);
    }

    /**
     * adds opacity to all nodes and connectors on the canvas
     */
    setNodesUnexecuted() {
        const elems = document.getElementsByClassName('node');
        for (const elemsKey in elems) {
            if (typeof elems[elemsKey] === 'object' && !elems[elemsKey].classList.contains('start-node_')) {
                this.renderer.addClass(elems[elemsKey], 'notExecutedNode');
            }
        }
        this.flowBuilderService.setUnexecutedStyles();
    }

    resetNodeStyle() {
        const elems = document.getElementsByClassName('node');
        for (const elemsKey in elems) {
            if (typeof elems[elemsKey] === 'object' && elems[elemsKey].classList.contains('notExecutedNode')) {
                this.renderer.removeClass(elems[elemsKey], 'notExecutedNode');
            }
        }
    }

    /**
     * Use this to listen to flowEvents once backend is working
     */
    setUpFlowEventListener() {
        this.selectFlowEventPathSubscription = this.store.select(selectFlowEventPath).subscribe(
            eventPath => {
                if (eventPath.flowId !== this.sharedService.getFlowRef && this.stateService.getFlowMode() === FlowModeState.PREVIEW_MODE) {
                    this.updateFlow.emit(eventPath.flowId);
                    this.setNodesUnexecuted();
                }
                this.setExecutedNodeStyle(eventPath.source, eventPath.target);
            },
        );
    }

    start(testDetailsPanel?: MatExpansionPanel) {
        this.emulatorChannelConfig = this.flowManagerService.getChannelsById(this.selectedChannel.toString());
        this.showEmulatorDialog = true;
        this.emulatorMessages = [];
        this.setNodesUnexecuted();
        this.zoomService.scrollTo('start');
        this.cdr.markForCheck();

        const startEmulatorMessage: EmulatorMessage = {
            messageType: EmulatorMessageTypes.START,
            user: this.userInfo['user_id'],
            tabId: this.utils.currentTabId(),
            flowId: this.sharedStorage.getFlowRef,
            entityId: this.sharedStorage.getEntityId(),
            entityType: this.sharedStorage.getEntityType().toUpperCase(),
            sessionId: this.sessionId,
            clientId: 42,
            sourceId: this.sourceId.value,
            channelId: this.selectedChannel,
            channelRouteId: this.route.value === this.isValidRoute() ? null : this.route.value,
            mediaMetaData: {
                src: '',
                bubbleType: 'text',
            },
            message: null
        };

        switch (this.selectedChannel) {
            case USSD:
                startEmulatorMessage.mnoSessionId = this.mnoSessionId.value || 'null';
                startEmulatorMessage.channelMessageProperties = {
                    network: this.network.value,
                    imsi: this.imsi.value || 'none',
                };
                startEmulatorMessage.message = this.route.value;

                this.emulatorReplyMessages.next(startEmulatorMessage);
                break;
            case WHATSAPP:
            case SMS:
                startEmulatorMessage.channelMessageProperties = {
                    messageId: 'UUID',
                };
                const fromValue = this.sourceId.value || '2799900001';
                startEmulatorMessage.channelPayload = {
                    integrationId: this.route.value,
                    integrationName: 'Test Integration',
                    triggerContactBookFlow: this.triggerContactBookFlow.value || false,
                    event: {
                        moText: [
                            {
                                channel: CHANNEL_NAME[this.selectedChannel],
                                messageId: 'test-message-' + Math.floor(Math.random() * 100000),
                                relatedMessageId: null,
                                relatedClientMessageId: null,
                                from: fromValue,
                                to: this.sourceId.value,
                                timestamp: moment.now(),
                                content: '',
                                charset: 'UTF-8',
                                whatsapp: {
                                    profileName: 'Profile Name',
                                    ...(this.isBsuid.value ? { userId: fromValue } : {}),
                                },
                            },
                        ],
                    },
                };

                break;
            case WEBCHAT:
            case RCS:
                startEmulatorMessage.channelMessageProperties = {
                    messageId: 'UUID',
                    conversationId: 'UUID',
                };
                startEmulatorMessage.channelPayload = {
                    integrationId: this.route.value,
                    integrationName: 'Test Integration',
                    event: {
                        moText: [
                            {
                                channel: CHANNEL_NAME[this.selectedChannel],
                                messageId: 'test-message-' + Math.floor(Math.random() * 100000),
                                relatedMessageId: null,
                                relatedClientMessageId: null,
                                from: '2799900001',
                                to: this.sourceId.value,
                                timestamp: moment.now(),
                                content: '',
                                charset: 'UTF-8',
                            }
                        ],
                    },
                };
        }

        this._websocketEmulatorSubject$.next(startEmulatorMessage);

        // focus
        if (testDetailsPanel) {
            testDetailsPanel.close();
        }
        this.focusResponseInput = true;
        setTimeout(() => {
            this.responseInput.nativeElement.focus();
        }, 0);
    }

    send(msg?) {
        if (this.emulatorResponse.value || msg) {
            let channelProps;
            const channelPayload = null;
            const message = msg ? msg : this.emulatorResponse.value;
            switch (this.selectedChannel) {
                case USSD:
                    channelProps = {
                        network: this.network.value,
                        imsi: this.imsi.value || 'none',
                    };
                    break;
                case WHATSAPP:
                case SMS:
                case RCS:
                    const translate: OutboundTranslator = {
                        type: 'text',
                        content: message,
                        channelId: this.selectedChannel,
                        integrationId: this.route.value,
                        to: this.sourceId.value,
                        isBsuid: this.isBsuid.value,
                        triggerContactBookFlow: this.triggerContactBookFlow.value,
                    };
                    const data = outboundTranslator(translate);
                    this.orcaSend(data.mediaData, data.channelPayload);
                    return;
                default:
                    channelProps = {};
            }

            const replyEmulatorMessage: EmulatorMessage = {
                messageType: EmulatorMessageTypes.MESSAGE_REPLY,
                user: this.userInfo['user_id'],
                tabId: this.utils.currentTabId(),
                sessionId: this.sessionId,
                message: this.selectedChannel === USSD ? message : null,
                clientId: 42,
                sourceId: this.sourceId.value,
                channelId: this.selectedChannel,
                channelRouteId: this.route.value,
                channelMessageProperties: channelProps,
                channelPayload: channelPayload,
                mediaMetaData: {
                    src: '',
                    bubbleType: 'text',
                },
            };

            // send to websocket
            this._websocketEmulatorSubject$.next(replyEmulatorMessage);

            // send to display
            this.emulatorReplyMessages.next(replyEmulatorMessage);

            this.emulatorResponse.reset();
        }
    }

    orcaSend(mediaData: any, channelPayload: any) {
        mediaData ['messageStatus'] = 'send';
        const replyEmulatorMessage: EmulatorMessage = {
            messageType: EmulatorMessageTypes.MESSAGE_REPLY,
            user: this.userInfo['user_id'],
            tabId: this.utils.currentTabId(),
            flowId: this.sharedStorage.getFlowRef,
            sessionId: this.sessionId,
            message: null,
            clientId: 42,
            sourceId: this.sourceId.value,
            channelId: this.selectedChannel,
            channelRouteId: this.route.value,
            channelMessageProperties: {
                messageId: 'UUID',
            },
            channelPayload: channelPayload,
            mediaMetaData: mediaData,
        };

        // send to websocket
        this._websocketEmulatorSubject$.next(replyEmulatorMessage);

        // send to display
        this.emulatorReplyMessages.next(replyEmulatorMessage);

        this.emulatorResponse.reset();
    }

    toggleRestartPopup() {
        if (this.showRestartPopUp) {
            this.showRestartPopUp = false;
        } else {
            this.showRestartPopUp = true;
            const popover = this.bubbleRef.nativeElement;
            const popoverRect = popover.getBoundingClientRect();
            const questionMarkRect = this.questionMarkRef.nativeElement.getBoundingClientRect();
            const left = questionMarkRect.left - (popoverRect.width) + (questionMarkRect.width * 1.5);
            popover.style.left = `${left}px`;
        }
        this.shouldFocus();
    }

    restart() {
        this.inputState = 'text';
        this.inputPlaceholder = INPUT_PLACEHOLDER.START;
        this.showMedia = false;
        this.showDismiss = false;
        this.emulatorDisplayMessages$ = this.getEmulatorMessages();
        this.showEmulatorDialog = false;
        this.showRestartPopUp = false;
        this.emulatorMessages = [];
        this.responseInput.nativeElement.value = '';
        this.sendReleaseMsg();
        this.resetNodeStyle();
        this.flowBuilderService.setDefaultStyles();
        this.store.dispatch(clearEmulatorStateAction());
        this.cdr.markForCheck();
    }

    sendReleaseMsg() {
        const replyEmulatorMessage: EmulatorMessage = {
            messageType: EmulatorMessageTypes.RELEASE_SESSION,
            user: this.userInfo['user_id'],
            tabId: this.utils.currentTabId(),
            sessionId: this.sessionId,
            message: this.selectedChannel === USSD ? '' : null,
            clientId: 42,
            sourceId: this.sourceId.value,
            channelId: this.selectedChannel,
            channelRouteId: this.route.value,
            channelMessageProperties: {},
            channelPayload: {},
            mediaMetaData: undefined,
        };

        this._websocketEmulatorSubject$.next(replyEmulatorMessage);
    }

    private initializeWithUserInfo(userInfo) {
        this.userInfo = userInfo;
    }

    shouldFocus() {
        if (this.focusResponseInput) {
            this.responseInput.nativeElement.focus();
        }
    }

    dismiss() {
        this.store.dispatch(clearEmulatorStateAction());
        this.showDismiss = false;
        this.emulatorDisplayMessages$ = this.getEmulatorMessages();
        this.sessionId = '';
        this.start();
    }

    uploadFileHandler() {
        this.clearUpload();
        const fileUpload = this.fileUpload.nativeElement;
        fileUpload.onchange = () => {
            this.uploadInProgress(fileUpload.files);
        };
        fileUpload.click();
    }

    checkImage(format) {
        return format.split('/')[0] === 'image';
    }

    uploadInProgress(files) {
        if (files.length !== 1) {
            swalMini({
                type: 'error',
                title: 'Please select 1 file!',
            });
            return;
        }

        const file: File = files[0];

        this.inputState = 'uploading';

        this.uploadProgressAction = {
            status: 'uploading',
            progress: 0,
            fileName: file.name,
            uploadCompleted: false,
            size: filesize(file.size),
            error: false,
            src: null,
        };

        this.cdr.markForCheck();

        const reader: FileReader = new FileReader();
        reader.onloadend = (e) => {
            const data = e.target.result;
            const wordArray = CryptoJS.lib.WordArray.create(data);
            const encrypted = CryptoJS.SHA256(wordArray).toString();

            const url = URL.createObjectURL(file);

            if (this.checkImage(file.type)) {
                const img: HTMLImageElement = new Image();

                img.onload = () => {
                    const resolution = `${img.width}x${img.height}`;
                    this.uploadFileAction(file, encrypted, resolution);
                };

                img.src = url;
            } else {
                this.uploadFileAction(file, encrypted);
            }

            this.mediaData = {
                downloadUrl: url,
                contentType: file.type,
                fileName: file.name,
                sha256Hash: encrypted,
                caption: '',
                byteSize: file.size,
            };

        };

        reader.readAsArrayBuffer(file);
    }

    uploadFileAction(file, encrypted, resolution?) {
        this.canceled = false;
        this.uploadMediaData = {file, encrypted, resolution};

        if (file.size > 10485760) {
            this.uploadProgressAction.status = 'file size exceeds 10mb';
            this.uploadProgressAction.error = true;
            return;
        }

        this.assetsService.setFileData(file, encrypted, resolution, 'Uploaded from preview', true).subscribe(
            (res: UploadRes) => {
                if (res && res.customMetadata && res.uploadURL) {
                    this.mediaData.reference = res.reference;
                    this.assetsService.uploadFile(file, res).subscribe((event) => {
                        // @ts-ignore
                        const {loaded, total, type} = event;

                        if (type === 1) {
                            this.uploadProgressAction.progress = Math.ceil((loaded * 100) / total);
                            this.cdr.markForCheck();
                            if (this.canceled === true) {
                                this.canceled = false;
                                this.uploadProgressAction.status = 'failed';
                                this.uploadProgressAction.error = true;
                                throw new Error();
                            }
                        }

                        if (type === 4) {
                            this.uploadProgressAction.status = 'complete';
                            this.uploadProgressAction.src = res.uploadURL;
                            this.cdr.markForCheck();
                        }
                    });
                } else {
                    this.uploadProgressAction.status = 'failed';
                    this.uploadProgressAction.error = true;
                    // this.clearUpload();
                }
            },
            () => {
                this.uploadProgressAction.status = 'failed';
                this.uploadProgressAction.error = true;
                // this.clearUpload();
            },
        );
    }

    uploadVoiceNote(file, hash) {
        return this.assetsService.setFileData(file, hash, null, 'Voice note', true).pipe(
            switchMap((res: UploadRes) => {
                if (res && res.customMetadata && res.uploadURL) {
                    return this.assetsService.uploadFile(file, res).pipe(
                        filter((event) => event.type === 4),
                        map((event) => {
                            if (event.type === 4) {
                                return {
                                    status: true,
                                    reference: res.reference,
                                };
                            }
                        }),
                    );
                } else {
                    return of({
                        status: false,
                    });
                }
            }),
        );
    }

    clearUpload() {
        this.inputState = 'text';
        this.uploadProgressAction = {
            status: null,
            progress: 0,
            fileName: null,
            uploadCompleted: false,
            size: 0,
            error: false,
            src: null,
            reference: null,
        };
        this.uploadMediaData = {
            file: null,
            encrypted: null,
            resolution: null,
        };
    }

    cancelUploadHandler() {
        this.clearUpload();
        this.canceled = true;
    }

    retryUploadHandler() {
        this.uploadFileHandler();
    }

    sendFileHandler() {
        this.clearUpload();
        this.sendMedia(this.mediaData);
    }

    closeModal() {
        this.previewModal = {
            isModalOpen: false,
            previewType: '',
            src: '',
        };
    }

    cancelRecording() {
        this.inputState = 'text';
    }

    // tslint:disable-next-line:no-shadowed-variable
    changeInputState(state: InputState) {
        this.inputState = state;
    }

    sendMedia(content: ContentMedia) {
        const translate: OutboundTranslator = {
            type: 'media',
            content: content,
            channelId: this.selectedChannel,
            integrationId: this.route.value,
            to: this.sourceId.value,
        };

        const translation = outboundTranslator(translate);
        this.orcaSend(translation.mediaData, translation.channelPayload);
    }

    sendVoiceNote(voiceNoteData: VoiceNoteData) {
        const data = voiceNoteData.blob;

        const fileOfBlob = new File([data], 'voiceNote.wav', {
            type: voiceNoteData.contentType,
        });

        const reader: FileReader = new FileReader();
        reader.onloadend = (e) => {
            const voicedata = e.target.result;
            const wordArray = CryptoJS.lib.WordArray.create(voicedata);
            const encrypted = CryptoJS.SHA256(wordArray).toString();

            this.uploadVoiceNote(fileOfBlob, encrypted).subscribe((response) => {
                if (response.status) {
                    const content: ContentMedia = {
                        contentType: voiceNoteData.contentType,
                        byteSize: voiceNoteData.blobSize,
                        sha256Hash: encrypted,
                        caption: null,
                        downloadUrl: voiceNoteData.downloadLink,
                        fileName: 'voiceNote',
                        reference: response['reference'],
                    };
                    this.sendMedia(content);
                }
                this.inputState = 'text';
            });
        };

        reader.readAsArrayBuffer(data);
    }

    sendContact(contact: Contact) {
        this.showSendContactCard = false;
        const translate: OutboundTranslator = {
            type: 'contact',
            content: contact,
            channelId: WHATSAPP,
            integrationId: this.route.value,
            to: this.sourceId.value,
        };

        const translation = outboundTranslator(translate);
        this.orcaSend(translation.mediaData, translation.channelPayload);
    }

    cancelShowLocationView() {
        this.inputState = 'text';
    }

    onShareLocationClick(locationMessage: LocationMessage) {
        const content: ContentLocation = {
            contentType: 'location/location',
            ...locationMessage,
        };

        const translate: OutboundTranslator = {
            type: 'location',
            content: content,
            channelId: WHATSAPP,
            integrationId: this.route.value,
            to: this.sourceId.value,
        };

        const translationResponse = outboundTranslator(translate);

        this.orcaSend(translationResponse.mediaData, translationResponse.channelPayload);
    }

    onInteractiveMessageClick(interactiveMessage: InteractiveMessage) {
        this.clientsMap$.subscribe(x => {
            this.entityName = x.find((y: any) => y.key === this.sharedStorage.globalEnvironment.entityId).value;
        });

        const content: ContentInteractive = {
            contentType: interactiveMessage.type + '/' + interactiveMessage.type,
            title: this.entityName,
            replyMessage: interactiveMessage.replyMessage,
            postbackData: interactiveMessage.postbackData,
            messageDisplay: interactiveMessage.messageDisplay,
            message: interactiveMessage.message,
            relatedClientMessageId: interactiveMessage.relatedClientMessageId,
        };

        const translate: OutboundTranslator = {
            type: interactiveMessage.type,
            content: content,
            channelId: this.selectedChannel,
            integrationId: this.route.value,
            to: this.sourceId.value,
        };

        const translationResponse = outboundTranslator(translate);

        this.orcaSend(translationResponse.mediaData, translationResponse.channelPayload);
    }

    toggleShowAdditionalSettings() {
        this.showAdditionalSettings = !this.showAdditionalSettings;
    }

    getCMSData(element) {
        return {
            contentId: element.lable,
            size: 17,
        };
    }

    checkIsFormValid() {
        const {network, route, sourceId} = this.emulatorFormGroup.value;
        if (sourceId && route) {
            if (route !== DEFAULT_NOT_VALID_EMULATOR_ROUTE_NAME) {
                if (this.selectedChannel === 7) {
                    return network;
                }
                return true;
            }
        }
        return false;
    }

    changeRoute(event) {
        if (event.option.value === 'This Flow') {
            if (this.startFlow.flowId !== this.sharedService.getFlowRef) {
                this.updateFlow.emit(this.startFlow.flowId);
            }
        } else {
            const routes = this.filteredRoutesList[this.selectedChannel];
            const route = find(routes, {name: event.option.value});
            if (route) {
                this.updateFlow.emit(route.flowName);
            }
        }
    }

    openSendContactCard() {
        this.showSendContactCard = true;
    }

    closeSendContact() {
        this.showSendContactCard = false;
    }

    onSendLocationClick(event) {
        this.inputState = 'location';
    }

    contactSendingIsNotDisplayed() {
        return !this.showSendContactCard;
    }

}
